export const FETCH_USER_LOGIN = 'FETCH_USER_LOGIN';
export const FETCH_USER_LOGIN_SUCCESS = 'FETCH_USER_LOGIN_SUCCESS';
export const FETCH_USER_LOGIN_FAILURE = 'FETCH_USER_LOGIN_FAILURE';
export const CLEAR_LOGIN_USER = 'CLEAR_LOGIN_USER';

export const CLEAR_ERROR_MESSAGE = 'CLEAR_ERROR_MESSAGE';